import { render, staticRenderFns } from "./UserTargets.vue?vue&type=template&id=b45e8d0a&"
import script from "./UserTargets.vue?vue&type=script&lang=js&"
export * from "./UserTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports